/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from 'graphql-tag';

export const GET_USER_LIST = gql`
  query GetUserList($input: GetUserListInput, $roleInput: RoleListInput) {
    getUserList(input: $input) {
      currentPage
      pageSize
      totalCount
      totalPages
      data {
        vuid
        userId
        email
        firstName
        lastName
        fullName
        emailVerified
        image
        accountStatus
        createdAt
        org {
          orgId
          name
          description
          email
          website
          fullAddress
          primaryContactNo
          logo
          socialLinks
          country
        }
        bannerImg
        address {
          addressLine1
          addressLine2
          addressLine3
          city
          state
          zipcode
          country
        }
        occupation
        bio
        primaryContactNo
        kyc {
          name
          type
          doc
          status
        }
        nationality

        kycSubmitted
      }
    }
    getRoleList(input: $roleInput)
  }
`;
